import { connect } from 'react-redux'
import RolePage from '..'
import {
  addNewRound,
  updateNewRound,
  exportCandidate,
  getCorporateData,
  getDegreeList,
  getDepartmentList,
  getDomainList,
  getExportFiledData,
  getJobRoleList,
  getRoleFilter,
  getScheduleFilter,
  getStatusFilter,
  getYear,
  getInstituteData,
  getEligibilityCriteriaQualification,
  exportCSV,
  getJobCategory,
  archiveRole,
  unarchiveRole,
} from '../actions'
import { duplicateRole } from '../../Roles/actions'
const getRoundData = state => state?.ats?.roundData
const getPreviewData = state => state?.ats?.previewData

const updatedRoundData = state => state?.ats?.updateRoundData
const getJobRolePreview = state => state?.ats?.getJobRolePreview
const selectors = {
  getRoundData,
  updatedRoundData,
  getPreviewData,
  getJobRolePreview,
}
const mapStateToProps = state => ({
  roundData: selectors.getRoundData(state),
  updateRoundData: selectors.updatedRoundData(state),
})

const mapDispatchToProps = {
  getJobRoleList,
  getCorporateData,
  getInstituteData,
  addNewRound,
  updateNewRound,
  exportCandidate,
  getExportFiledData,
  getDepartmentList,
  getDegreeList,
  getDomainList,
  getRoleFilter,
  getStatusFilter,
  getScheduleFilter,
  getYear,
  getEligibilityCriteriaQualification,
  exportCSV,
  getJobCategory,
  duplicateRole,
  archiveRole,
  unarchiveRole,
}

export default connect(mapStateToProps, mapDispatchToProps)(RolePage)
